<template>
  <div>
    <loading v-if="cargando" />
    <div
      class="modal fade"
      id="modal-reporte-turnos-tif"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
      data-backdrop="static"
      data-keyboard="false"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header bg-primary text-white">
            <h5 class="modal-title">
              <i class="fas fa-filter mr-2"></i>
            </h5>
            <button
              type="button"
              class="close text-white"
              data-dismiss="modal"
              aria-label="Cerrar"
              ref="cerrarModal"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <p class="text-muted small">
              Selecciona los filtros para generar el reporte.
            </p>
            <div class="form-row">
              <div class="form-group col-md-6">
                <label class="small mb-1">Fecha inicial</label>
                <input
                  type="date"
                  class="form-control form-control-sm"
                  v-model="form.fecha_inicial"
                  :class="
                    $v.form.fecha_inicial.$invalid ? 'is-invalid' : 'is-valid'
                  "
                />
                <div class="invalid-feedback">
                  La fecha inicial es requerida.
                </div>
              </div>
              <div class="form-group col-md-6">
                <label class="small mb-1">Fecha final</label>
                <input
                  type="date"
                  class="form-control form-control-sm"
                  v-model="form.fecha_final"
                  :class="
                    $v.form.fecha_final.$invalid ? 'is-invalid' : 'is-valid'
                  "
                />
                <div class="invalid-feedback">La fecha final es requerida.</div>
              </div>
              <div class="form-group col-md-6">
                <label class="small mb-1">Vehículo TIF</label>
                <v-select
                  v-model="vehiculo"
                  placeholder="Buscar placa..."
                  label="placa"
                  class="form-control form-control-sm p-0"
                  :options="listasForms.vehiculos"
                  :filterable="false"
                  @search="buscarVehiculos"
                  @input="selectVehiculo"
                ></v-select>
              </div>
              <div class="form-group col-md-6">
                <label class="small mb-1">Bloque TIF</label>
                <v-select
                  v-model="bloque"
                  placeholder="Seleccionar bloque..."
                  label="nombre"
                  class="form-control form-control-sm p-0"
                  :options="listasForms.bloques"
                  @input="selectBloque"
                ></v-select>
              </div>
            </div>
            <div
              v-if="rangoInvalido"
              class="alert alert-warning py-2 mb-0 small"
            >
              <i class="fas fa-exclamation-triangle mr-1"></i>
              La fecha final no puede ser menor a la fecha inicial.
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              <i class="fas fa-times mr-1"></i>
              Cancelar
            </button>
            <button
              type="button"
              class="btn btn-success"
              :disabled="$v.form.$invalid || rangoInvalido"
              @click="generar()"
            >
              <i class="fas fa-download mr-1"></i>
              Generar y descargar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { required } from "vuelidate/lib/validators";
import vSelect from "vue-select";
import Loading from "../../../../components/Loading";

export default {
  name: "ReporteTurnosTif",
  components: {
    Loading,
    vSelect,
  },
  data() {
    return {
      cargando: false,
      vehiculo: null,
      bloque: null,
      form: {
        fecha_inicial: "",
        fecha_final: "",
        vehiculo_id: null,
        bloque_id: null,
      },
      listasForms: {
        vehiculos: [],
        bloques: [],
      },
    };
  },
  validations: {
    form: {
      fecha_inicial: {
        required,
      },
      fecha_final: {
        required,
      },
    },
  },
  computed: {
    rangoInvalido() {
      if (!this.form.fecha_inicial || !this.form.fecha_final) {
        return false;
      }
      return this.form.fecha_final < this.form.fecha_inicial;
    },
  },
  methods: {
    limpiarModal() {
      this.vehiculo = null;
      this.bloque = null;
      this.listasForms.vehiculos = [];
      this.form = {
        fecha_inicial: "",
        fecha_final: "",
        vehiculo_id: null,
        bloque_id: null,
      };
    },
    getBloquesTif() {
      axios
        .get("api/admin/bloques/lista", {
          params: { linea_negocio_id: 3 },
        })
        .then((response) => {
          this.listasForms.bloques = response.data;
        })
        .catch((error) => {
          this.$swal({
            icon: "error",
            title: "Ocurrió un error al cargar bloques" + error,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
        });
    },
    buscarVehiculos(search, loading) {
      if (search != "") {
        let me = this;
        loading(true);
        axios
          .get("/api/admin/vehiculos/lista", {
            params: {
              placa: search,
              linea_negocio_id: [3],
            },
          })
          .then(function(response) {
            me.listasForms.vehiculos = response.data;
            loading(false);
          })
          .catch(function(error) {
            loading(false);
            me.$swal({
              icon: "error",
              title: "Ocurrió un error al buscar vehículos" + error,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
          });
      }
    },
    selectVehiculo() {
      this.form.vehiculo_id = this.vehiculo ? this.vehiculo.id : null;
    },
    selectBloque() {
      this.form.bloque_id = this.bloque ? this.bloque.id : null;
    },
    generar() {
      if (this.$v.form.$invalid || this.rangoInvalido) {
        return;
      }

      this.cargando = true;
      axios({
        method: "GET",
        url: "/api/funcionariosFrontera/reportes/turnosTif/export",
        params: {
          fecha_inicial: this.form.fecha_inicial,
          fecha_final: this.form.fecha_final,
          vehiculo_id: this.form.vehiculo_id || null,
          bloque_id: this.form.bloque_id || null,
        },
      })
        .then((response) => {
          this.cargando = false;
          if (this.$refs.cerrarModal) {
            this.$refs.cerrarModal.click();
          }
          if (response.data && response.data.url) {
            location.href = response.data.url;
          }
          this.$swal({
            icon: "success",
            title: "Reporte generado correctamente...",
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
        })
        .catch((e) => {
          this.cargando = false;
          this.$swal({
            icon: "error",
            title: "Ocurrió un error, vuelva a intentarlo..." + e,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
        });
    },
  },
  mounted() {
    this.getBloquesTif();
  },
};
</script>
